import { gamePieceColors } from "../../../enums/enums";

export const stevenPattern = [
    [gamePieceColors.gem3, gamePieceColors.gem3, gamePieceColors.gem3, gamePieceColors.gem3, gamePieceColors.gem3, gamePieceColors.gem3],
    [gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem4],
    [gamePieceColors.gem3, gamePieceColors.gem3, gamePieceColors.gem3, gamePieceColors.gem3, gamePieceColors.gem3, gamePieceColors.gem3],
    [gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem4],
];

export const amethystPattern = [
    [gamePieceColors.gem1, gamePieceColors.gem3, gamePieceColors.gem3, gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem2],
    [gamePieceColors.gem1, gamePieceColors.gem3, gamePieceColors.gem3, gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem2],
    [gamePieceColors.gem1, gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem3, gamePieceColors.gem3, gamePieceColors.gem2],
    [gamePieceColors.gem1, gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem3, gamePieceColors.gem3, gamePieceColors.gem2],
];

export const pearlPattern = [
    [gamePieceColors.gem1, gamePieceColors.gem1, gamePieceColors.gem2, gamePieceColors.gem2, gamePieceColors.gem3, gamePieceColors.gem3],
    [gamePieceColors.gem4, gamePieceColors.gem1, gamePieceColors.gem1, gamePieceColors.gem2, gamePieceColors.gem2, gamePieceColors.gem3],
    [gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem1, gamePieceColors.gem1, gamePieceColors.gem2, gamePieceColors.gem2],
    [gamePieceColors.gem3, gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem1, gamePieceColors.gem1, gamePieceColors.gem2],
];

export const garnetPattern = [
    [gamePieceColors.gem2, gamePieceColors.gem1, gamePieceColors.gem2, gamePieceColors.gem1, gamePieceColors.gem2, gamePieceColors.gem1],
    [gamePieceColors.gem2, gamePieceColors.gem1, gamePieceColors.gem2, gamePieceColors.gem1, gamePieceColors.gem2, gamePieceColors.gem1],
    [gamePieceColors.gem2, gamePieceColors.gem1, gamePieceColors.gem2, gamePieceColors.gem1, gamePieceColors.gem2, gamePieceColors.gem1],
    [gamePieceColors.gem2, gamePieceColors.gem1, gamePieceColors.gem2, gamePieceColors.gem1, gamePieceColors.gem2, gamePieceColors.gem1],
];

export const peridotPattern = [
    [gamePieceColors.gem1, gamePieceColors.gem3, gamePieceColors.gem3, gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem2],
    [gamePieceColors.gem1, gamePieceColors.gem3, gamePieceColors.gem3, gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem2],
    [gamePieceColors.gem1, gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem3, gamePieceColors.gem3, gamePieceColors.gem2],
    [gamePieceColors.gem1, gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem3, gamePieceColors.gem3, gamePieceColors.gem2],
];

export const jasperPattern = [
    [gamePieceColors.gem1, gamePieceColors.gem2, gamePieceColors.gem3, gamePieceColors.gem3, gamePieceColors.gem2, gamePieceColors.gem1],
    [gamePieceColors.gem1, gamePieceColors.gem2, gamePieceColors.gem3, gamePieceColors.gem3, gamePieceColors.gem2, gamePieceColors.gem1],
    [gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem1, gamePieceColors.gem1, gamePieceColors.gem3, gamePieceColors.gem3],
    [gamePieceColors.gem4, gamePieceColors.gem4, gamePieceColors.gem1, gamePieceColors.gem1, gamePieceColors.gem3, gamePieceColors.gem3],
];


export const yellowDiamondPattern = [
    [gamePieceColors.gem2, gamePieceColors.gem3, gamePieceColors.gem4, gamePieceColors.gem1, gamePieceColors.gem2, gamePieceColors.gem3],
    [gamePieceColors.gem1, gamePieceColors.gem2, gamePieceColors.gem3, gamePieceColors.gem4, gamePieceColors.gem1, gamePieceColors.gem2],
    [gamePieceColors.gem4, gamePieceColors.gem1, gamePieceColors.gem2, gamePieceColors.gem3, gamePieceColors.gem4, gamePieceColors.gem1],
    [gamePieceColors.gem3, gamePieceColors.gem4, gamePieceColors.gem1, gamePieceColors.gem2, gamePieceColors.gem3, gamePieceColors.gem4],
];
